import { useLayoutEffect, useRef} from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function GetInTouch() {

      const gettouchref = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
    
      gsap.to(".git-marquee", {
        xPercent: -50,
        repeat: -1,
        duration: 25,
        ease: "none"
      });
    }, gettouchref);

    return () => ctx.revert();
  }, []);


   return (
     <section className="get-in-touch" ref={gettouchref}>
    <div className="git-marquee">
        <div className="git-marq-col">
            <div className="cross-wrap is-git">
                <div className="git-line-v"></div>
                <div className="git-line-h"></div>
            </div>
            <div className="git-text-wrap">
                <div className="git-text-stroke">Want Our Services?</div>
            </div>
            <div className="cross-wrap is-git">
                <div className="git-line-v"></div>
                <div className="git-line-h"></div>
            </div>
            <div className="git-text-wrap">
                <div className="git-text-stroke">Want Our Services?</div>
            </div>
        </div>
        <div className="git-marq-col">
            <div className="cross-wrap is-git">
                <div className="git-line-v"></div>
                <div className="git-line-h"></div>
            </div>
            <div className="git-text-wrap">
                <div className="git-text-stroke">Want Our Services?</div>
            </div>
            <div className="cross-wrap is-git">
                <div className="git-line-v"></div>
                <div className="git-line-h"></div>
            </div>
            <div className="git-text-wrap">
                <div className="git-text-stroke">Want Our Services?</div>
            </div>
        </div>
    </div>
    <div className="git-action-wrapper">
        <div className="action is-git"><a href="/contact"
                className="btn w-inline-block">
                <div className="btn-text-wrap">
                    <div className="btn-text-white">Get Connected</div>
                    {/* <div className="btn-text-black-ab">Get Connected</div> */}
                </div>
                {/* <div className="whipe-white"></div> */}
            </a></div>
        <div className="whipe-yellow"></div>
    </div>
</section>
   )
}